module.exports = __webpack_public_path__ + "img/traffic-cone.809cac95.svg";